import React from "react";
import styles from "./Button.module.css";
const Button = (props) => {
  const { type } = props;
  let classes;
  if (props.className) {
    classes =
      styles["button"] + " " + props.className;
  } else {
    classes = styles["button"];
  }
  return (
    <button type={type} className={classes}>
      {props.children}
    </button>
  );
};

export default React.memo(Button);
